import { useCallback, useRef } from 'react'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useSectionId } from '@v4/components/common/SectionItem'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import ThemeSelector from '@v4/utils/selectors/ThemeSelector'

const useEditorMeta = ({ metaData, categoryId, index, key }) => {
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const isLockedFieldEditable = ScorecardSelector.useIsLockedFieldEditable?.()
	const metaDataRef = useRef(metaData)
	const sectionId = useSectionId()
	const pageId = PageBuilderSelector.usePageId()
	const { setMeta } = PageBuilderSelector.useActions()
	const { setMeta: setThemeMeta } = ThemeSelector.useActions()
	const activeTierId = PageBuilderSelector.useMetaItemActiveTierId({
		sectionId,
		group: metaData?.config.group,
		categoryId,
		index,
	})

	const editable = !isQuestionBuilderMode && !(!isLockedFieldEditable && !!metaData?.locked)

	metaDataRef.current = metaData

	const handleChange = useCallback(
		value => {
			const curMetaData = metaDataRef.current
			const { group } = curMetaData?.config || {}
			if (!curMetaData || !group || curMetaData.metaValue === value) return

			const newMetaData = curMetaData.clone()
			newMetaData.fill({
				landing_page_id: pageId,
				landing_page_section_id: sectionId,
				category_id: categoryId ?? null,
				meta_key: key,
				score_tier_id: activeTierId ?? null,
				meta_key_index: index ?? null,
				repeatable_group: typeof index === 'number' ? group : null,
			}).metaValue = value

			if (newMetaData.themeSectionKey) {
				setThemeMeta({ sectionKey: newMetaData.themeSectionKey, data: newMetaData.data })
				return
			}

			setMeta({
				group,
				data: newMetaData.data,
			})
		},
		[activeTierId, categoryId, index, key, pageId, sectionId, setMeta, setThemeMeta],
	)

	return {
		editable,
		handleChange: editable ? handleChange : undefined,
	}
}

export default useEditorMeta
